import type { IChangeFlightEligibilityClasses } from "@b2bportal/core-types";
import type { IChangeFlightEligibilityData } from "@tenant/flights";
import { Button, ButtonTypeEnum } from "@tenant/ui";

export interface IChangeFlightEligibilityLoadFailedProps {
  classes?: Partial<
    IChangeFlightEligibilityClasses & {
      contactSupportBtn: string;
      tryAgainBtn: string;
    }
  >;
  copy: IChangeFlightEligibilityData["copy"];
  onContactSupport: () => void;
  onTryAgain: () => void;
}

export const ChangeFlightEligibilityLoadFailed = (
  props: IChangeFlightEligibilityLoadFailedProps
) => {
  const { classes, copy, onContactSupport, onTryAgain } = props;

  return (
    <div className={classes?.modalContent}>
      <div className={classes?.contentHeader}>
        <span className={classes?.contentTitle}>{copy.loadFailed.title}</span>
        <span className={classes?.contentBody}>{copy.loadFailed.body}</span>
      </div>
      <div className={classes?.contentActions}>
        <Button
          buttonType={ButtonTypeEnum.Primary}
          className={classes?.tryAgainBtn}
          onClick={onTryAgain}
        >
          {copy.tryAgainBtn}
        </Button>
        <Button
          buttonType={ButtonTypeEnum.Secondary}
          className={classes?.contactSupportBtn}
          onClick={onContactSupport}
        >
          {copy.contactSupportBtn}
        </Button>
      </div>
    </div>
  );
};
